import React from 'react'
import { styled } from 'src/ui/theme'
import { Icons } from 'src/ui/icons'

const Wrapper = styled.li`
  list-style: none outside;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.black.bg};
`

type Props = {
  children: string
}

export const InnerListItem = ({ children }: Props) => {
  return (
    <Wrapper>
      <Icons.Bullet />
      {children}
      <Icons.Rub />
    </Wrapper>
  )
}
